import { axios } from '@/services/axios';

const createCustomSIPHeader = async (formData, currentScope) => {
    const res = await axios.post('/TRECustomHeader', formData, {
        headers: {
            'X-RequestScope': currentScope,
        },
    });
    return res.data;
};

export default createCustomSIPHeader;
